<template>
  <div id="layout">
    <navbar></navbar>
    <breadcrumbs />
    <div class="container-fluid mt-3 layout-container">
      <div class="row">
        <div class="col-lg-2 col-md-3 pr-0 d-md-block ">
          <innerSidebar />
        </div>
        <div
          class=" col-md-9 col-12 main-content-wrap"
          v-bind:class="
            $route.path == '/settings/members' ? 'col-lg-10' : 'col-lg-9'
          "
        >
          <router-view :key="$route.path" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import navbar from "./components/navbar";
import breadcrumbs from "./components/breadcrumbs";
import innerSidebar from "./components/inner_sidebar";

export default {
  name: "layout",
  components: {
    navbar,
    breadcrumbs,
    innerSidebar,
  },
  methods: {
    togNa() {
      window.$(".innside-tog-wrap").click(() => {
        console.log("enejndjend");
      });
    },
  },
};
</script>

<style type="text/css" scoped>
#layout {
  padding: 70px 0px;
}
@media screen and (max-width: 990px) {
  #layout {
    padding: 0px 0px;
  }
}
</style>
